import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Clock } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { applyPageMeta, SITE_URL } from '../components/SEOMetaTags';

/**
 * Lista ghidurilor: /ghid/
 * Rol SEO: link-uri interne crawlabile spre toate articolele.
 */
const PAGE_META = {
  title: 'Ghiduri Carte Funciară – Explicații Simple | CF-Extras.ro',
  description: 'Ghiduri practice despre cartea funciară: ce înseamnă CF, cum citești un extras, cât este valabil, cum afli numărul cadastral și ce verifici la cumpărare.',
  canonical: `${SITE_URL}/ghid/`
};

function GuidesHub() {
  const [guides, setGuides] = useState([]);

  useEffect(() => { applyPageMeta(PAGE_META); }, []);

  useEffect(() => {
    fetch('/seo-data/ghid/index.json')
      .then(r => r.json())
      .then(d => setGuides(d.guides || []))
      .catch(e => console.error('Eroare încărcare ghiduri:', e));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <nav className="text-sm mb-4">
            <ol className="flex items-center gap-x-2 text-gray-600">
              <li><Link to="/" className="hover:text-emerald-600">Acasă</Link></li>
              <li>/</li>
              <li className="text-gray-900 font-medium">Ghiduri</li>
            </ol>
          </nav>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 flex items-center gap-3">
            <BookOpen className="w-8 h-8 text-emerald-600" aria-hidden="true" />
            Ghiduri despre cartea funciară
          </h1>
          <p className="text-lg text-gray-600">
            Explicații clare, fără limbaj juridic complicat, despre extrasul de carte funciară și situațiile în care ai nevoie de el.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-10 max-w-4xl">
        <ul className="grid md:grid-cols-2 gap-6">
          {guides.map(g => (
            <li key={g.slug}>
              <Link
                to={`/ghid/${g.slug}/`}
                className="block h-full bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition"
              >
                <h2 className="text-xl font-bold text-gray-900 mb-2">{g.h1}</h2>
                <p className="text-gray-600 mb-3">{g.excerpt}</p>
                <span className="text-sm text-gray-500 flex items-center gap-1">
                  <Clock className="w-4 h-4" aria-hidden="true" /> {g.readMinutes} minute de citit
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <Footer />
    </div>
  );
}

export default GuidesHub;
